
export default {
  name: 'BbDashboardCard',
  props: {
    fillWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classList() {
      return ['bb-dashboard-card', ...(this.fillWidth ? ['bb-dashboard-card--fill-width'] : [])];
    },
    hasFooterContent() {
      return !!this.$slots?.footer?.length;
    },
  },
};
